import { Box, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  name: string;
  actions?: React.ReactNode;
}

const WidgetHeader = ({ name, actions, children }: PropsWithChildren<Props>) => {
  return (
    <Stack spacing={2.5} sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pr: 4 }}>
        <Typography variant="h6">{name}</Typography>
        {actions}
      </Box>
      {children}
    </Stack>
  );
};

export default WidgetHeader;
